import React from 'react';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { resolveBackendMessage } from '../../../../../../Utils/apiMessages';
import { formatFullTime } from '../../../../utils/messageRenderUtils';
import MessageInfoSection from '../MessageInfoSection/MessageInfoSection';
import { getDangerTitleColor, getMessageDetailsThemeColors } from '../MessageDetails.helpers';

const { Text } = Typography;

const MessageFailureInfo = ({ message, isDarkMode }) => {
    const { t, i18n } = useTranslation();
    const themeColors = getMessageDetailsThemeColors(isDarkMode);

    if (!message?.status?.failed && !message?.failure) return null;

    return (
        <MessageInfoSection
            title={t('failure_information')}
            titleColor={getDangerTitleColor(isDarkMode)}
        >
            <Space direction="vertical" style={{ width: '100%' }}>
                {message.status?.failed_at && (
                    <Text style={{ color: themeColors.text }}>{t('failed_at')}: {formatFullTime(message.status.failed_at, i18n?.language)}</Text>
                )}

                {message.failure && (
                    <div>
                        <Text strong style={{ color: themeColors.text }}>{t('error_message')}:</Text>
                        <div style={{
                            marginTop: 4,
                            padding: 8,
                            background: isDarkMode ? 'rgba(255, 77, 79, 0.1)' : '#fff1f0',
                            borderRadius: 4,
                            borderLeft: '3px solid #ff4d4f'
                        }}>
                            <Text style={{ color: themeColors.text, whiteSpace: 'pre-wrap' }}>
                                {resolveBackendMessage(t, {
                                    message_code: message.failure.message_code,
                                    message: message.failure.message,
                                    message_data: message.failure.message_data
                                })}
                            </Text>
                        </div>
                    </div>
                )}
            </Space>
        </MessageInfoSection>
    );
};

export default MessageFailureInfo;
